import * as React from 'react';
import { Alert } from '@fluentui/react-northstar'
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { clearMessage } from '../../store/Meeting/actions';
import { useDispatch } from 'react-redux';

const MessageBox = () => {
    const dispatch = useDispatch();
    const {
        message: refMessage
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const [message, setMessage] = React.useState(refMessage);
    React.useEffect(() => {
        if (refMessage && refMessage.length > 0) {
            setMessage(refMessage);
            setTimeout(() => {
                dispatch(clearMessage());
            }, 5000);
        } else {
            setMessage('');
        }
    }, [refMessage])

    return <div style={{
        display: 'flex',
        flex: 1,        
        justifyContent: 'center',
        position: 'relative',
        left: '10%'
    }}>{message && <Alert style={{ background: '#daf5d8', border: 'none', color: '#000000' }} dismissible={true} success={true} content={message} />}</div>
};
export default MessageBox
